import { useMemo } from 'react';
import { useAsyncServiceEngineContext } from './context/AsyncServicesEngineContext';

/**
 * Hook che dato un id fornisce i dati di un servizio asincrono.
 */
export function useAsyncService(id: string | null | undefined) {
  const { services, axiosClient } = useAsyncServiceEngineContext();
  const service = useMemo(() => {
    if (!id) return null;

    if (!services) return null;

    return services.find(s => s.id === id) ?? null;
  }, [services, id]);

  return { service, axiosClient };
}
